export default __webpack_public_path__ + "static/logo-akebia-therapeutics-1b0e05b67e841ae9fd7eddc826142084.png";